import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';

import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Registro from './pages/Registro';
import ConsultaPersonalizada from './pages/ConsultaPersonalizada';

import EntrenadorDashboard from './pages/EntrenadorDashboard';
import UsuarioDashboard from './pages/UsuarioDashboard';
import GaleriaEjercicios from './pages/GaleriaEjercicios';
import AsignarEjercicios from './pages/AsignarEjercicios';
import HistorialRutinas from './pages/HistorialRutinas';
import ProgresoRutinas from './pages/ProgresoRutinas';

import PrivateRoute from './routes/PrivateRoute';
import { AuthProvider } from './context/AuthContext';

import FormularioContainer from './components/FormularioContainer';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 font-sans">
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registro" element={<Register />} />
            <Route path="/rutina-por-fase" element={<Registro />} />
            <Route path="/consulta-personalizada" element={<ConsultaPersonalizada />} />
            <Route path="/formulario" element={<FormularioContainer />} />

            <Route
              path="/entrenador"
              element={
                <PrivateRoute rolRequerido="entrenador">
                  <EntrenadorDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/usuario"
              element={
                <PrivateRoute rolRequerido="usuario">
                  <UsuarioDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/galeria"
              element={
                <PrivateRoute rolRequerido="entrenador">
                  <GaleriaEjercicios />
                </PrivateRoute>
              }
            />
            <Route
              path="/asignar"
              element={
                <PrivateRoute rolRequerido="entrenador">
                  <AsignarEjercicios />
                </PrivateRoute>
              }
            />
            <Route
              path="/historial"
              element={
                <PrivateRoute rolRequerido="entrenador">
                  <HistorialRutinas />
                </PrivateRoute>
              }
            />
            <Route
              path="/progreso"
              element={
                <PrivateRoute rolRequerido="usuario">
                  <ProgresoRutinas />
                </PrivateRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </div>
    </Router>
  );
}

export default App;
